import { NgModule } from '@angular/core';
import { DdrLoadIframeDirective } from './ddr-load-iframe.directive';



@NgModule({
  declarations: [
    DdrLoadIframeDirective
  ],
  imports: [],
  exports: [DdrLoadIframeDirective]
})
export class DdrLoadIframeModule { }
